module.exports = __webpack_public_path__ + "static/img/暂无任务1.1db7676a.png";